export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 py-10 md:py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-violet-500 to-violet-800">
            <span className="font-display text-sm font-black text-white">M</span>
          </span>
          <div className="font-display text-sm font-semibold tracking-tight text-white">
            Maximilian <span className="text-violet-400">Marketing</span>
          </div>
        </div>

        <div
          data-testid="footer-copyright"
          className="font-mono-label text-[10px] text-white/40"
        >
          © {year} Maximilian Marketing · Designed & built by Max
        </div>

        <div className="flex items-center gap-6 font-mono-label text-[10px] text-white/40">
          <a
            href="tel:+12013065226"
            data-testid="footer-phone"
            className="hover:text-violet-300 transition-colors"
          >
            201-306-5226
          </a>
          <a
            href="mailto:rmstuss@gmail.com"
            data-testid="footer-email"
            className="hover:text-violet-300 transition-colors"
          >
            rmstuss@gmail.com
          </a>
        </div>
      </div>
    </footer>
  );
}
